import { Dialog, styled } from "@mui/material";
import { StyledDialogProps } from "./types";

const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'resizable',
})<StyledDialogProps>(({ theme, resizable, fullScreen }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  ...(resizable &&
    !fullScreen && {
    '& .MuiPaper-root.MuiDialog-paper': {
      resize: 'both',
      minWidth: '500px',
      minHeight: '500px',
      overflow: 'auto',
    },
  }),
}));

export default StyledDialog
